<template>
  <div class="FeatureScreening">
    <div class="titleDiv">
      <div class="title">
        <span>参数筛选</span>
      </div>
    </div>
    <a-row class="generalParameter">
      <a-col :span="8" v-for="(item, index) in fieldQuery">
        <a-form-item :labelCol="labelColAll" :wrapperCol="wrapperColAll">
          <a-select
            :allowClear="true"
            v-model="item.field"
            showSearch
            :filter-option="filterOption"
            optionFilterProp="label"
            placeholder="选择筛选参数"
            @change="changeFieldQuery"
            style="width: 100%"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          >
            <a-select-option
              v-for="(item, index) in fieldQueryList"
              :key="index"
              :value="item.id"
              :disabled="item.disabled">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-icon type="close-square" theme="filled" class="delIcon" @click="delFeature(item, index)"/>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item :label-col="labelColAll" :wrapper-col="wrapperColAll">
          <a-button block type="dashed" icon="plus" @click="addFeature" class="addBtn_general">添加</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getTableData } from '@/api/fieldManage'

export default {
  name: 'FeatureScreening',
  data () {
    return {
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      // 特性筛选列表
      fieldQuery: [],
      // 特性树列表
      fieldQueryList: []
    }
  },
  created () {
    this.getFieldQueryList()
  },
  methods: {
    // 获取特性筛选列表
    getFieldQueryList () {
      const params = {
        paging: false
      }
      getTableData(params).then(res => {
        if (res.status === 0) {
          this.fieldQueryList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 参数字段搜索
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.indexOf(input) >= 0
      )
    },
    // 给已选择的特性添加disabled
    findChildren (data, idList) {
      data.forEach(item => {
        item.disabled = idList.includes(item.id)
      })
    },
    // 树选择
    changeFieldQuery () {
      const idList = []
      this.fieldQuery.forEach(item => {
        idList.push(item.field)
      })
      this.findChildren(this.fieldQueryList, idList)
    },
    // 删除
    delFeature (item, index) {
      this.fieldQuery.splice(index, 1)
      const idList = []
      this.fieldQuery.forEach(item => {
        idList.push(item.field)
      })
      this.findChildren(this.fieldQueryList, idList)
    },
    // 添加
    addFeature () {
      this.fieldQuery.push({
        field: ''
      })
    },
    // 重置参数
    reset () {
      this.fieldQuery = []
      this.findChildren(this.fieldQueryList, [])
    },
    // 获取查询参数，并返回给父组件
    getParamQuery () {
      const featureIdList = []
      try {
        this.fieldQuery.forEach(item => {
          if (item.field) {
            featureIdList.push(item.field)
          } else {
            throw new Error('请选择筛选参数')
          }
        })
      } catch (err) {
        this.$message.error(err.message)
        return false
      }
      return featureIdList
    }
  }
}
</script>

<style lang="less" scoped>
.FeatureScreening {
  margin-top: 20px;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: rgba(8, 64, 159, 1);
  }
}
.generalParameter {
  /deep/.ant-col-8 {
    padding-right: 12px;
    .ant-form-item-children {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-select {
        width: calc(100% - 28px);
        margin-right: 8px;
      }
      .delIcon {
        font-size: 20px;
        color: red;
      }
    }
  }
}

/deep/.ant-select-dropdown{
  .ant-select-dropdown-content {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item-disabled {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }
  }
}
</style>
